import React, { Component } from 'react';

class FlexListComponent extends Component {
  // expected props: width proportions, centered or not, list of contents, style of contents

  // mock props
  state = {
    text_style: {},
    uniformWidths: true
  };

  render() {
    return (
      <div
        style={{
          display: 'flex',
          ...this.props.divStyle
        }}
      >
        {this.props.list.map((entry, i) => {
          return (
            <div
              style={{
                width: this.props.uniformWidths
                  ? 100 / this.props.list.length + '%'
                  : this.state.widths[i]
              }}
            >
              {entry.map(textItem => (
                <div style={{ ...this.props.text_style }}>{textItem}</div>
              ))}
            </div>
          );
        })}
      </div>
    );
  }
}

export default FlexListComponent;
